export function activateCategory(categoryKey: string): void {
  const blocked = document.querySelectorAll<HTMLScriptElement>(
    `script[type="text/plain"][data-dp-consent="${categoryKey}"]:not([data-dp-activated])`,
  );
  blocked.forEach((placeholder) => {
    const real = document.createElement("script");
    real.type = "text/javascript";
    const src = placeholder.getAttribute("data-src");
    if (src) real.src = src;
    else real.textContent = placeholder.textContent ?? "";
    for (const attr of Array.from(placeholder.attributes)) {
      if (["type", "data-dp-consent", "data-src", "data-dp-activated"].includes(attr.name)) continue;
      real.setAttribute(attr.name, attr.value);
    }
    placeholder.setAttribute("data-dp-activated", "true");
    placeholder.parentNode?.insertBefore(real, placeholder.nextSibling);
  });
}

export function activateGranted(categoryKeys: string[]): void {
  categoryKeys.forEach(activateCategory);
}
